import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// ChildCategory - Get All (Read)
export const GetAllChildCategory = createAsyncThunk(
  "masters/childcategory/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.ProductManage.ChildCategory}?name=${
          filter?.name || ""
        }&subcategory_id=${filter?.subcategory_id || ""}&category_id=${
          filter?.category_id || ""
        }&page=${filter?.page || IDS.PAGE}&per_page=${
          filter?.per_page || IDS.PERPAGE
        }`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ChildCategory - Get (Read)
export const GetChildCategory = createAsyncThunk(
  "masters/childcategory/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.ProductManage.ChildCategory}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ChildCategory - Create (Add)
export const AddChildCategory = createAsyncThunk(
  "masters/childcategory/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.ProductManage.ChildCategory, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// ChildCategory - Update
export const UpdateChildCategory = createAsyncThunk(
  "masters/childcategory/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.ProductManage.ChildCategory}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
// {
//     name: data.name,
//     country_id: data.country_id,
//     state_id: data.state_id
// }

// ChildCategory - Delete
export const DeleteChildCategory = createAsyncThunk(
  "masters/childcategory/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.ProductManage.ChildCategory}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ChildCategory - Status
export const StatusChildCategory = createAsyncThunk(
  "masters/childcategory/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.ProductManage.ChildCategory}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "childcategory",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllChildCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllChildCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllChildCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetChildCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetChildCategory.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetChildCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AddChildCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddChildCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddChildCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateChildCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateChildCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (childcategory) => childcategory.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateChildCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteChildCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteChildCategory.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter(
          (childcategory) => childcategory.id !== action.payload
        );
      })
      .addCase(DeleteChildCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StatusChildCategory.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusChildCategory.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(StatusChildCategory.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
